import axiosInstance from '../../util/axiosAPI';
import { API_URL } from '../../config';

export default class ReceiverService {

    constructor() { }

    setApproxCoordinate() {
        const url = `${API_URL}/api/gnss/controller/approxpos/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    setApproxCoordinateAsync() {
        const url = `${API_URL}/api/gnss/controller/approxpos/async/`;
        return axiosInstance.post(url).then(response => response.data);
    }

    getControllerSettings() {
        const url = `${API_URL}/api/gnss/settings/1/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    updateControllerSettings(settings) {
        const url = `${API_URL}/api/gnss/settings/1/`;
        return axiosInstance.patch(url, settings).then(response => response.data);
    }

    restartController() {
        const url = `${API_URL}/api/gnss/controller/restart/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    getCoordinates(data) {
        const url = `${API_URL}/api/gnss/coordinates/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    setCoordinate(data) {
        const url = `${API_URL}/api/gnss/coordinates/`;
        return axiosInstance.post(url, data).then(response => response.data);
    }

    deleteCoordinate(id) {
        const url = `${API_URL}/api/gnss/coordinates/${id}/`;
        return axiosInstance.delete(url).then(response => response.data);
    }

    getControllerStatus() {
        const url = `${API_URL}/api/gnss/controller/status/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    getCasterStatus() {
        const url = `${API_URL}/api/gnss/caster/status/`;
        return axiosInstance.get(url).then(response => response.data);
    }

    restartCaster() {
        const url = `${API_URL}/api/gnss/caster/restart/`;
        return axiosInstance.get(url).then(response => response.data);
    }

}